'use strict';

import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {h, Fragment} from 'preact';
import {useParams} from 'react-router-dom';
import GoodPreview from '../Good/Item';
import axios from '../../utility/axios';
import Pagination from '../Pagination';
import useQuery from '../../utility/useQuery';
import supplant from '../../utility/supplant';
import {block, unblock} from '../../../src/block-ui';

export default function Goods(props) {
    const query = useQuery();
    const params = useParams();
    const page = ~~query.get('start');
    const initialPage = useMemo(() => page, []);

    // It can be updated if there are no items provided initially
    const [canUpdate, setCanUpdate] = useState(!props.items);

    useEffect(() => {
        if (page !== initialPage) {
            setCanUpdate(true);
        }
    }, [page, initialPage]);

    useEffect(() => {
        if (!canUpdate) {
            return;
        }

        const url = supplant(props.url, {...params, page});

        block();

        axios.get(url, {
            params: {
                locale: window.LOCALE,
            }
        }).then(response => {
            if (typeof props.onUpdate !== 'undefined') {
                props.onUpdate(response.data.items);
            }

            $(document).scrollTop($('#products').offset().top - 100);
            unblock();
        });
    }, [props.url, page, params, canUpdate]);

    const view = props.view || 'grid';

    return (
        <>
            {props.items && (
                <>
                    {props.items.map(item => (
                        <GoodPreview product={item} view={view} key={item.id} />
                    ))}

                    <Pagination {...props.pagination} />
                </>
            )}
        </>
    );
}
